import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class CropService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<Crop[]> => {
    return this.apiHttp.get<Crop[]>("crops");
  };

  public get = (id: number): Observable<Crop> => {
    return this.apiHttp.get<Crop>(`crops/${id}`);
  };
}

export interface Crop {
  id: number;
  name: string;
  isActive: boolean;
  averageDaysForSeedMaturity: number;
  isDonorNeeded: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/crop.service.ts